module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/spot-empty-state.a705bf21.svg";